import React, { Component, lazy, Suspense } from 'react';
import {
  Badge,
  Button, ButtonDropdown, ButtonGroup, ButtonToolbar,
  Card, CardBody, CardFooter, CardHeader, CardTitle,
  Col,
  Dropdown, DropdownItem, DropdownMenu, DropdownToggle,
  Progress,
  Row,
  Table,
  Modal, ModalBody, ModalHeader,
} from 'reactstrap';
import cookie from 'react-cookies'
import {CustomCard, CustomCardHeader} from '../CustomComponents/Cards'
import Wall from './utils/Wall'
import ava from '../../assets/img/avatars/9.jpg';
import SummaryWidgets from '../Widgets/SummaryWidgets';
import { ScaleLoader } from 'react-spinners'
import ability from '../../configurations/casl/ability'
import moment from 'moment'

import { connect } from 'react-redux'
import { fetchDashboardUnit } from '../../redux/actions/dashboard/aDashboard-Unit'
import { fetchDashboardAlert } from '../../redux/actions/dashboard/aDashboard-Alert'
import { fetchUnitList } from '../../redux/actions/units/aUnits-UnitList'
import { fetchTaskList } from '../../redux/actions/tasks/aTask-TaskList'
import { fetchTaskActivity } from '../../redux/actions/tasks/aTask-ActivityList'
import {fetchMemberList} from '../../redux/actions/satuan/aSatuan-MemberList';
import { fas } from '@fortawesome/free-solid-svg-icons';

const tasks = [
  {id: 1, code: 'ADMT0001', description: 'Input jadwal perawatan'},
  {id: 2, code: 'TGSA0011', description: 'Pemeliharaan unit ALP-114'},
  {id: 3, code: 'ADMT0002', description: 'Input jadwal perawatan'},
  {id: 4, code: 'TGSA0012', description: 'Perawatan unit  LEV-110'},
  {id: 5, code: 'TGSA0014', description: 'Pemeliharaan unit  SWJ-223'},
  {id: 6, code: 'TGSA0015', description: 'Pemeliharaan unit  AKV-014'},
]

const activities = [
  {id: 1, pic: 'Mayor Rudi Haryasandi', description: 'melakukan pemeliharaan terhadap unit AKV - 014.', time: '10:30 '},
  {id: 2, pic: 'Sersan Hadi Guntoro', description: 'melakukan pemeliharaan terhadap unit LEV - 225.', time: '10:20'},
  {id: 3, pic: 'Mayor Rudi Haryasandi', description: 'melakukan pemeliharaan terhadap unit AKV - 014.', time: '10:30 '},
  {id: 4, pic: 'Sersan Hadi Guntoro', description: 'melakukan pemeliharaan terhadap unit LEV - 225.', time: '10:20'},
  {id: 5, pic: 'Mayor Rudi Haryasandi', description: 'melakukan pemeliharaan terhadap unit AKV - 014.', time: '10:30 '},
  {id: 6, pic: 'Sersan Hadi Guntoro', description: 'melakukan pemeliharaan terhadap unit LEV - 225.', time: '10:20'},
  {id: 7, pic: 'Mayor Rudi Haryasandi', description: 'melakukan pemeliharaan terhadap unit AKV - 014.', time: '10:30 '},
  {id: 8, pic: 'Sersan Hadi Guntoro', description: 'melakukan pemeliharaan terhadap unit LEV - 225.', time: '10:20'},
]

const wallData = {
  report: {
    ready: 110,
    warning: 13,
    critical: 5,
  },
  unitList: [
    {
      typeId: 0,
      typeName: 'RANPUR BERODA RANTAI',
      typeList: [
        {
          unitId: 0,
          unitName: 'LEOPARD 2A4RI',
          unitStatus: {
            ready: 18,
            warning: 3,
            critical: 1,
          }
        },
        {
          unitId: 1,
          unitName: 'PINDAD HARIMAU 2A4RI',
          unitStatus: {
            ready: 17,
            warning: 1,
            critical: 0,
          }
        },
      ]
    },
    {
      typeId: 1,
      typeName: 'RANPUR BERODA BAN',
      typeList: [
        {
          unitId: 4,
          unitName: 'DOOSAN 2A4RI',
          unitStatus: {
            ready: 18,
            warning: 3,
            critical: 1,
          }
        },
        {
          unitId: 8,
          unitName: 'PINDAD BADAK 2A4RI',
          unitStatus: {
            ready: 17,
            warning: 1,
            critical: 0,
          }
        },
        {
          unitId: 9,
          unitName: 'PINDAD APS 2A4RI',
          unitStatus: {
            ready: 17,
            warning: 1,
            critical: 0,
          }
        },
      ]
    },
    {
      typeId: 3,
      typeName: 'RANPUR UMUM BAN',
      typeList: [
        {
          unitId: 14,
          unitName: 'DOOSAN HQ',
          unitStatus: {
            ready: 18,
            warning: 3,
            critical: 1,
          }
        },
        {
          unitId: 28,
          unitName: 'MISSLE BADAK 2A4RI',
          unitStatus: {
            ready: 17,
            warning: 1,
            critical: 0,
          }
        },
        {
          unitId: 39,
          unitName: 'BIMA APS 2A4RI',
          unitStatus: {
            ready: 17,
            warning: 1,
            critical: 0,
          }
        },
      ]
    },
  ]
}


class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      goToAlert: false
    }
  }

  componentWillMount() {
    if(cookie.load('division_id_view_dashboard') == 0){
      this.props.fetchDashboardUnit()
      this.props.fetchTaskActivity({division_id: cookie.load('division_id'), limit: 8})
    } else {
      this.props.fetchDashboardUnit({division_id: cookie.load('division_id_view_dashboard')})
      this.props.fetchTaskActivity({division_id: cookie.load('division_id_view_dashboard'), limit: 8})
    }
    this.props.fetchDashboardAlert()
    this.props.fetchUnitList()
    this.props.fetchTaskList({status: [2,3]})
    this.props.fetchMemberList();
    //console.log(cookie.load('division_id_view_dashboard'))
  }

  goToAlert(){
    if(this.props.alertList.length>0){
      this.props.history.push('/pengingat')
    }
  }

  goToTask(){
    if(this.props.taskList.filter(x => x.status == 2 || x.status == 3).length>0){
      this.props.history.push('/persetujuan')
    }
  }

  findValue = (data) => {
    let datas
    let result
    if(data == undefined){
      data = []
    } 
    if(cookie.load('division_id_view_dashboard')){
      datas = data.filter(x=> x.division_id == cookie.load('division_id_view_dashboard'))
    } else {
      datas = data.filter(x=> x.division_id == cookie.load('division_id'))
    }

    return datas
  }

  render() {
    const {unitList, unitProgress, taskList, taskProgress, memberList, inProgressMember, alertList, alertProgress} = this.props

    let tasks = []
    let units = []
    let members = []
    let alerts = []
    if(taskList != undefined){
      tasks = taskList
    }
    if(unitList != undefined){
      units = unitList
    }
    if(memberList != undefined){
      members = memberList
    }
    if(alertList != undefined){
      alerts = alertList
    }

    let alutsista = this.findValue(units).filter(x => x.is_alutsista).length
    let combatan = this.findValue(units).filter(x => x.is_alutsista == false).length
    let member = this.findValue(members).length
    let task = this.findValue(tasks).length
    let alert = this.findValue(alerts).length
    let alertLeader = this.findValue(tasks.filter(x => x.status == 0 || x.status == 1)).length

    return (
      <div className="animated fadeIn" hidden={!ability.can('view','user dashboard')}>
        <div style={{marginTop:"24px"}}>
         <Row style={{marginBottom:"24px"}} >
            <Col className="grid-five">
                <SummaryWidgets header={alutsista.toString()} mainText={'ALUTSISTA'} variant={'0'}>
                  {this.props.unitProgress?
                    <center style={{marginTop: '16px'}}><ScaleLoader color={'#fff'} loading={this.props.unitProgress} /></center>
                  :
                    null
                  }
                </SummaryWidgets>
            </Col>
            <Col className="grid-five">
                <SummaryWidgets header={combatan.toString()} mainText={'NON - KOMBATAN'} variant={'0'}>
                  {this.props.unitProgress?
                    <center style={{marginTop: '16px'}}><ScaleLoader color={'#fff'} loading={this.props.unitProgress} /></center>
                  :
                    null
                  }
                </SummaryWidgets>
            </Col>
            <Col className="grid-five">
                <SummaryWidgets header={member.toString()} mainText={'PERSONIL'} variant={'0'}>
                {this.props.inProgressMember?
                    <center style={{marginTop: '16px'}}><ScaleLoader color={'#fff'} loading={this.props.inProgressMember} /></center>
                  :
                    null
                  }
                  </SummaryWidgets>
            </Col>
            <Col className="grid-five">
                <SummaryWidgets header={task.toString()} mainText={'PENUGASAN'} variant={'0'}>
                  {this.props.taskProgress?
                    <center style={{marginTop: '16px'}}><ScaleLoader color={'#fff'} loading={this.props.taskProgress} /></center>
                  :
                    null
                  }
                </SummaryWidgets>
            </Col>
            <Col className="grid-five" >
                {cookie.load('role') != 'leader'?
                  <SummaryWidgets header={alert.toString()} mainText={'PENGINGAT'} onClick={() => this.goToAlert()}>
                    {this.props.alertProgress?
                      <center style={{marginTop: '16px'}}><ScaleLoader color={'#fff'} loading={this.props.alertProgress} /></center>
                    :
                      null
                    }
                  </SummaryWidgets>
                :
                  <SummaryWidgets header={alertLeader.toString()} mainText={'PENGINGAT'} onClick={() => this.goToTask()}>
                    {this.props.alertProgress?
                      <center style={{marginTop: '16px'}}><ScaleLoader color={'#fff'} loading={this.props.taskProgress} /></center>
                    :
                      null
                    }
                  </SummaryWidgets>
                }
            </Col>
          </Row>
        <Row>
          <Col md="8">
            {this.props.inProgress?
              <center><ScaleLoader color={'#fff'} loading={this.props.inProgress} /></center>
            :
              <Wall data={this.props.dashboardUnit} counter={this.props.dashboardCounter} />
            }
          </Col>
          <Col md="4">
              <Row>
                <Col>
                  <CustomCard backgroundColor='rgba(148, 148, 148, 0.15)' border='#9F9F9F'>
                    <CustomCardHeader background='rgba(225, 228, 225, 0.15)' title='PENUGASAN'>
                      <i class="fa fa-long-arrow-right" style={{fontSize: 20, color: '#fff', cursor: 'pointer'}} onClick={() => this.props.history.push('/penugasan')}></i>
                    </CustomCardHeader>
                      {this.props.taskProgress?
                        <center><ScaleLoader color={'#fff'} loading={this.props.taskProgress} /></center>
                      :
                        <div style={{padding: 20, paddingTop: 0}}>
                            {  
                                this.props.taskList != undefined && this.props.taskList.length > 0 ?
                                this.props.taskList.sort((x,y) => (x.approve_date > y.approve_date)?1:-1).slice(Math.max(this.props.taskList.length - 5, 0)).map((task, index) => (
                                    <p style={{fontSize: 14, color: '#fff', marginBottom: 8}}><span style={{color: '#18A0FB'}}>[{task.id}]</span> - {task.type} unit <span style={{color: '#18A0FB'}}>{task.unit_name}</span></p>
                                )) : null
                            }
                        </div>
                      }
                  </CustomCard>
                </Col>
              </Row>
              <Row>
                <Col>
                  <CustomCard backgroundColor='rgba(148, 148, 148, 0.15)' border='#9F9F9F'>
                    <CustomCardHeader background='rgba(225, 228, 225, 0.15)' title='AKTIVITAS TERBARU'>
                      <i class="fa fa-long-arrow-right" style={{fontSize: 20, color: '#fff', cursor: 'pointer'}}></i>
                    </CustomCardHeader>
                    {this.props.activityProgress?
                      <center><ScaleLoader color={'#fff'} loading={this.props.activityProgress} /></center>
                    :
                    <div style={{padding: 20, paddingTop: 0}}>
                        { //sort((x,y) => (moment(x.date).isBefore(moment(y.date)))?1:-1).slice(0, 7).
                            this.props.activityList.map((activity, index) => (
                              <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 8}}>
                                {/*<img src={ava} width="32" height="32" style={{borderRadius: '50%', margin: 0}} />
                                <p style={{fontSize: 14, color: '#fff', marginBottom: 0, marginLeft: 16}}><span style={{color: '#18A0FB'}}>{item.pic}</span> - {item.description} - <span style={{color: '#18A0FB'}}>{item.time}</span></p>*/}
                                
                                <p style={{fontSize: 14, color: '#fff', marginBottom: 0, marginLeft: 16}}>{activity.desc} - {moment(activity.date).format('hh:mm')}</p>
                              </div>
                            ))
                        }
                      </div>
                    }

                  </CustomCard>
                </Col>
              </Row>
          </Col>
        </Row>
      </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dashboardUnit: state.dashboardStore.dashboardUnit,
    dashboardCounter: state.dashboardStore.dashboardCounter,
    inProgress: state.dashboardStore.inProgress,
    alertList: state.alertStore.alertList,
    alertProgress: state.alertStore.inProgress,
    unitList: state.unitStore.unitList,
    unitProgress: state.unitStore.inProgress,
    taskList: state.taskStore.taskList,
    taskProgress: state.taskStore.inProgress,
    activityList: state.activityStore.activityList,
    activityProgress: state.activityStore.inProgress,
    memberList: state.memberStore.memberList,
    inProgressMember: state.memberStore.inProgress,
  }
}

export default connect(mapStateToProps, {fetchDashboardUnit, fetchDashboardAlert, fetchUnitList, fetchTaskList, fetchTaskActivity, fetchMemberList})(Dashboard)



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.js